import { createAsyncThunk, createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { Bet } from "interfaces/bet";
import { RootState } from "state/store";
import { getBetsPath, integratedMyBets } from "utils/backend-path-builders";
import { getRequest } from "utils/httpClient";

interface BetsState {
  bets: Bet[];
  loadingBets: boolean;
  error: string | null;
}

const initialState: BetsState = {
  bets: [],
  loadingBets: false,
  error: null,
};

export const fetchBets = createAsyncThunk<
Bet[], {groupId: string, contestEntryId: string, isIntegratedApp: boolean}, { rejectValue: string }
>("bets/fetchBets", 
  async ({groupId, contestEntryId, isIntegratedApp}, { rejectWithValue }) => {
    const path = isIntegratedApp
      ? integratedMyBets(contestEntryId)
      : getBetsPath(groupId, contestEntryId);

  try {
    return await getRequest(path);
  } catch (error) {
    console.error(`Error fetching bets`, error);
    return rejectWithValue("Failed to fetch bets");
  }
});

const betsSlice = createSlice({
  name: "bets",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBets.pending, (state: Draft<BetsState>) => {
        state.loadingBets = true;
        state.error = null;
      })
      .addCase(fetchBets.fulfilled, (state: Draft<BetsState>, action) => {
        state.loadingBets = false;
        state.error = null;

        state.bets = action.payload;
      })
      .addCase(fetchBets.rejected, (state: Draft<BetsState>, action) => {
        state.loadingBets = false;
        state.error = action.payload as string;
      })
    }
});

export const getBetsState = (state: RootState): BetsState => {
  return state.bets;
};

export default betsSlice.reducer;